import _ from 'lodash';
import React from 'react';
import { Button, Divider } from 'src/@vymo/ui/atoms';
import Text from 'src/@vymo/ui/atoms/text';
import { Card, NoData } from 'src/@vymo/ui/blocks';
import { Keys, locale } from 'src/i18n';
import { REVYRE_FORM } from 'src/modules/constants';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { renderDialog } from 'src/workspace/slice';
import { getActivityCardName } from './queries';
import { getEntityActivitiesBasedOnCode } from './selectors';
import styles from './index.module.scss';

function ActivityCard({ cardCode, entityId }) {
  const activities = useAppSelector((state) =>
    getEntityActivitiesBasedOnCode(state, entityId, cardCode),
  );

  const dispatch = useAppDispatch();

  const handleButtonOnClick = (activity) => {
    dispatch(
      renderDialog({
        id: REVYRE_FORM,
        props: {
          type: 'update',
          domainType: 'activity',
          workflowType: activity?.workflowType,
          activityType: activity?.activityType,
        },
      }),
    );
  };

  return (
    <Card data-test-id={`details-${cardCode}-card`}>
      <div className={styles.details__activityCard__header}>
        <Text type="h4">{getActivityCardName(cardCode)}</Text>
      </div>
      <Divider />
      {activities?.length === 0 ? (
        <NoData message={locale(Keys.NO_ACTIVITIES_FOUND)} />
      ) : (
        <div className={styles.details__activityCard__details}>
          {_.map(activities, (updatedActivity, index) => {
            const activity = {
              ...updatedActivity,
            };
            activity.schedule = activity?.schedule ?? {
              start: activity?.scheduleFromDate,
              end: activity?.scheduleToDate,
            };

            const startDate = new Date(activity?.schedule?.start);
            const endDate = new Date(activity?.schedule?.end);
            const date = startDate?.getDate();
            const month = startDate?.toLocaleString('default', {
              month: 'short',
            });
            const startTime = startDate?.toLocaleTimeString('en-IN', {
              hour: '2-digit',
              minute: '2-digit',
              hour12: true,
            });
            const endTime = endDate?.toLocaleTimeString('en-IN', {
              hour: '2-digit',
              minute: '2-digit',
              hour12: true,
            });
            const duration = (endDate.getTime() - startDate.getTime()) / 60000;

            return (
              <>
                <div className={styles.details__activityCard__card}>
                  <div className={styles.details__activityCard__card__avatar}>
                    <Text
                      classNames={
                        styles.details__activityCard__card__avatar__header
                      }
                      type="label"
                    >
                      {month}
                    </Text>
                    <Text
                      classNames={
                        styles.details__activityCard__card__avatar__footer
                      }
                      type="h4"
                    >
                      {date}
                    </Text>
                  </div>
                  <div className={styles.details__activityCard__card__details}>
                    <Text type="h6">{activity?.name}</Text>
                    <Text>{`${startTime} - ${endTime} · ${duration} mins`}</Text>
                    {cardCode !== 'completed' && (
                      <Button
                        variant="subtle"
                        onClick={() => handleButtonOnClick(activity)}
                      >
                        {locale(Keys.UPDATE)}
                      </Button>
                    )}
                  </div>
                </div>
                {Number(index) !== Number(activities?.length) - 1 && (
                  <Divider />
                )}
              </>
            );
          })}
        </div>
      )}
    </Card>
  );
}

export default ActivityCard;
